export enum LanguageEnum {
    EN = 'en',
    DE = 'de',
    ZH = 'zh',
    KO = 'ko',
    JA = 'ja',
}
